import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { SignupRequest } from '../../domain/types/auth'
import { AppError } from '../../shared/utils/error-handler'

export const useAuthQueries = () => {
  const queryClient = useQueryClient()

  // Signup Mutation
  const signupMutation = useMutation<boolean, Error, SignupRequest>({
    mutationFn: async (signupData: SignupRequest) => {
      const { authUseCase } = await import('../../di/container')
      return authUseCase.signup(signupData)
    },
    onSuccess: () => {
      // 회원가입 성공 시 필요한 처리
      console.log('Signup successful')
    },
    onError: (error: unknown) => {
      console.error('Signup error:', AppError.fromUnknown(error))
    }
  })

  return {
    signupMutation,
  }
}